/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/18/20
 * Time: 2:50 AM
 */

// /*global ZoomMtg*/

import React, {Component} from 'react';
import './JoinClass.scss'
import {withRouter} from "react-router";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import {connect} from "react-redux";
import {lang, language} from "../../../const/language";
import {Form} from "react-bootstrap";

import {Button, Card, CardBody, Col, Row} from "reactstrap";
import Header from "../../../components/Header/Header";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import {isAndroid} from "react-device-detect";

class App extends Component {

    state = {
        zoomBody: null,
        init: false,
        eduLabApp: ''
    }

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
    }

    onBack = () => {
        window.history.back();
    }

    install = () => {
        if (isAndroid){
            window.open('https://play.google.com/store/apps/details?id=us.zoom.videomeetings', '_blank');
        } else {
            window.open('https://apps.apple.com/us/app/id546505307', '_blank');
        }
    }

    render() {
        return (
            <div>
                <Header/>
                <main ref="main" className={"join-class"}>
                    <div className="intro">
                        <button className={"home-btn"}
                                onClick={() => this.onBack()}>
                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>

                    <Card>
                        <CardBody>
                            <div align="left">
                                {
                                    this.state.zoomBody !== null &&
                                    <>
                                        <Row>
                                            <Col className="colPadding" md={12}>
                                                <Form.Group as={Col} controlId="lessonName">
                                                    <Form.Label column>
                                                        <strong>{language[lang].InstallZoom}</strong>
                                                    </Form.Label>
                                                    <Button className="com-btn log-btn normal-txt "
                                                            onClick={() => this.install()}>
                                                        Zoom app එක install කරගන්න</Button>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            </div>
                        </CardBody>
                    </Card>

                </main>
                <CardsFooter/>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    currentModal: state.modal.currentModal,
    userObj: state.student.userObj
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
